import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface KpiCard {
  id: string;
  label: string;
  value: number;
  unit: string;
  delta: number;
  trend: "good" | "warning" | "bad";
  is_proxy?: boolean;
}

export interface LeadingIndicator {
  id: string;
  label: string;
  value: number;
  unit: string;
}

export interface MetricsData {
  has_data: boolean;
  period_days: number;
  kpis: KpiCard[];
  leading_indicators: LeadingIndicator[];
}

export function useMetrics(projectSlug?: string) {
  const query = useQuery({
    queryKey: queryKeys.metrics.dashboard(projectSlug ?? "org"),
    queryFn: () => {
      const params = new URLSearchParams();
      if (projectSlug) {
        params.set("project_id", projectSlug);
      }
      const qs = params.toString();
      return api<MetricsData>(`/api/v2/metrics${qs ? `?${qs}` : ""}`);
    },
  });

  return {
    metrics: query.data ?? null,
    loading: query.isLoading,
    error: query.error ? "delivery.loadError" : "",
  };
}
